const navToggle = document.querySelector("[data-nav-toggle]");
const header = document.querySelector("[data-header]");
const globalNav = document.querySelector("[data-global-nav]");
const navGroups = document.querySelectorAll("[data-nav-group]");
const navParents = document.querySelectorAll("[data-nav-parent]");
const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
const makuakeTeaserProductionHref = "/pages/kamano-2gou-makuake-preview?view=kamano-2gou-makuake-preview-live";
const makuakeTeaserLocalHref = "/pages/kamano-2gou-makuake-preview?view=kamano-2gou-makuake-preview-live";

const runWhenDomReady = (callback) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
    return;
  }
  callback();
};

const shopifyTemplateRoutes = new Map([
  ["/pages/products", { view: "products" }],
  ["/pages/recipes", { view: "recipes" }],
  ["/pages/technology", { view: "technology" }],
  ["/pages/no-keep-warm", { view: "no-keep-warm" }],
  ["/pages/no-water-level-line", { view: "no-water-level-line" }],
  ["/pages/concept", { view: "concept" }],
  ["/pages/why-donabe", { view: "why-donabe" }],
  ["/pages/craft-material", { view: "craft-material" }],
  ["/pages/how-to-use", { view: "how-to-use" }],
  ["/pages/support", { view: "support" }],
  ["/pages/faq", { view: "faq" }],
  ["/pages/parts-manual", { view: "parts-manual" }],
  ["/pages/journal", { view: "journal" }],
  ["/pages/news", { view: "news" }],
  ["/pages/legal", { view: "legal" }],
  ["/pages/privacy-policy", { path: "/pages/legal", view: "privacy-policy" }],
  ["/pages/specified-commercial-transactions", { path: "/pages/legal", view: "specified-commercial-transactions" }],
  ["/pages/terms-of-service", { path: "/pages/legal", view: "terms-of-service" }],
  ["/pages/refund-shipping-policy", { path: "/pages/legal", view: "refund-shipping-policy" }],
  ["/pages/recipe-mixed-rice", { view: "recipe-mixed-rice" }],
  ["/pages/recipe-roast-beef", { view: "recipe-roast-beef" }],
  ["/pages/recipe-salad-chicken", { view: "recipe-salad-chicken" }],
  ["/pages/recipe-steamed-vegetables", { view: "recipe-steamed-vegetables" }],
  ["/pages/recipe-porridge", { view: "recipe-porridge" }],
  ["/pages/recipe-chawanmushi", { view: "recipe-chawanmushi" }],
  ["/pages/recipe-hamburg", { path: "/pages/recipes", view: "recipe-hamburg" }],
  ["/pages/recipe-onsen-egg", { path: "/pages/recipes", view: "recipe-onsen-egg" }],
  ["/pages/recipe-steamed-chicken", { path: "/pages/recipes", view: "recipe-steamed-chicken" }],
  ["/pages/kamano-2gou-makuake-preview", { view: "kamano-2gou-makuake-preview-live" }],
  ["/products/kamano-donabe-2g", { view: "kamano-donabe-2g" }],
  ["/products/kamano-donabe-4g", { path: "/products/kamano-donabe-4合", view: "kamano-donabe-4g" }],
  ["/products/kamano-donabe-4合", { view: "kamano-donabe-4g" }],
  ["/products/kamano-komebitsu", { view: "kamano-komebitsu" }],
  ["/products/kamano-mushizara", { view: "kamano-mushizara" }],
  ["/products/kamano-stand", { view: "kamano-stand" }],
]);

const applyShopifyTemplateRoutes = () => {
  document.querySelectorAll('a[href^="/pages/"], a[href^="/products/"]').forEach((link) => {
    const rawHref = link.getAttribute("href");
    if (!rawHref) return;

    const target = new URL(rawHref, window.location.origin);
    const decodedPath = decodeURIComponent(target.pathname.replace(/\/$/, ""));
    const route = shopifyTemplateRoutes.get(decodedPath);
    if (!route) return;

    if (route.path) target.pathname = route.path;
    if (!target.searchParams.has("view")) target.searchParams.set("view", route.view);
    link.setAttribute("href", `${target.pathname}${target.search}${target.hash}`);
  });
};

applyShopifyTemplateRoutes();
runWhenDomReady(applyShopifyTemplateRoutes);

const applyMakuakeTeaserLinks = () => {
  document.querySelectorAll('[data-placeholder-link="shopify-teaser"]').forEach((link) => {
    link.setAttribute("data-production-href", makuakeTeaserProductionHref);
    link.setAttribute("href", makuakeTeaserLocalHref);
  });
};

applyMakuakeTeaserLinks();
runWhenDomReady(applyMakuakeTeaserLinks);

if (header) {
  const setHeaderState = () => {
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  };

  setHeaderState();
  window.addEventListener("scroll", setHeaderState, { passive: true });
}

const closeNavGroups = (exceptGroup) => {
  navGroups.forEach((group) => {
    if (group === exceptGroup) return;
    group.classList.remove("is-open");
    const button = group.querySelector("[data-nav-parent]");
    if (button) button.setAttribute("aria-expanded", "false");
  });
};

if (navToggle && header) {
  navToggle.addEventListener("click", () => {
    const isOpen = header.classList.toggle("is-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
    if (!isOpen) closeNavGroups();
  });
}

navParents.forEach((button) => {
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    const group = button.closest("[data-nav-group]");
    if (!group) return;
    const isOpen = !group.classList.contains("is-open");
    closeNavGroups(group);
    group.classList.toggle("is-open", isOpen);
    button.setAttribute("aria-expanded", String(isOpen));
  });
});

if (globalNav) {
  const normalizeKamanoPath = (path) => {
    const normalized = path.replace(/\/$/, "") || "/";
    if (normalized === "/") return "/";
    if (normalized.startsWith("/pages/recipe-")) return "/pages/recipes";
    return normalized;
  };
  const currentSectionPath = normalizeKamanoPath(window.location.pathname);
  const currentHash = window.location.hash;

  globalNav.querySelectorAll("a[href]").forEach((link) => {
    link.removeAttribute("aria-current");
    const target = new URL(link.getAttribute("href"), window.location.href);
    const pathMatches = normalizeKamanoPath(target.pathname) === currentSectionPath;
    const hashMatches = target.hash ? target.hash === currentHash : !currentHash;

    if (pathMatches && hashMatches) {
      link.setAttribute("aria-current", "page");
      const group = link.closest("[data-nav-group]");
      if (group) group.classList.add("is-current");
    }

    link.addEventListener("click", () => {
      header?.classList.remove("is-open");
      navToggle?.setAttribute("aria-expanded", "false");
      closeNavGroups();
    });
  });

  document.addEventListener("click", (event) => {
    if (!globalNav.contains(event.target)) closeNavGroups();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    header?.classList.remove("is-open");
    navToggle?.setAttribute("aria-expanded", "false");
    closeNavGroups();
  });
}

const lazyVideos = document.querySelectorAll("video[data-src]");

if (lazyVideos.length) {
  const loadLazyVideo = (video) => {
    const src = video.dataset.src;
    if (!src) return;

    video.src = src;
    video.removeAttribute("data-src");
    video.load();

    if (!motionQuery.matches && video.autoplay) {
      video.play().catch(() => {});
    }
  };

  if ("IntersectionObserver" in window) {
    const lazyVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadLazyVideo(entry.target);
          lazyVideoObserver.unobserve(entry.target);
        });
      },
      { rootMargin: "360px 0px" }
    );

    lazyVideos.forEach((video) => lazyVideoObserver.observe(video));
  } else {
    lazyVideos.forEach(loadLazyVideo);
  }
}

const filterButtons = document.querySelectorAll("[data-filter]");
const recipeCards = document.querySelectorAll("[data-recipe-grid] article");

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const filter = button.dataset.filter;
    filterButtons.forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");

    recipeCards.forEach((card) => {
      const shouldShow = filter === "all" || card.dataset.category === filter;
      card.hidden = !shouldShow;
      if (shouldShow) card.classList.add("is-visible");
    });
  });
});

document.querySelectorAll("[data-pdp-gallery]").forEach((pdpGallery) => {
  const mainImage = pdpGallery.querySelector("[data-pdp-main]");
  const galleryButtons = pdpGallery.querySelectorAll("[data-gallery-src]");

  if (!mainImage || !galleryButtons.length) return;

  galleryButtons.forEach((button) => {
    button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false");
    button.addEventListener("click", () => {
      const nextSrc = button.dataset.gallerySrc;
      if (!nextSrc) return;

      mainImage.src = nextSrc;
      mainImage.alt = button.dataset.galleryAlt || "";
      galleryButtons.forEach((item) => {
        item.classList.remove("is-active");
        item.setAttribute("aria-pressed", "false");
      });
      button.classList.add("is-active");
      button.setAttribute("aria-pressed", "true");
    });
  });
});

const bundleOptions = document.querySelectorAll("[data-bundle-option]");

if (bundleOptions.length) {
  const bundlePrice = document.querySelector("[data-bundle-price]");
  const bundleName = document.querySelector("[data-bundle-name]");
  const bundleCta = document.querySelector("[data-bundle-cta]");

  const updateBundleChoice = (input) => {
    const price = input.dataset.price || "";
    const name = input.dataset.name || "購入情報";

    bundleOptions.forEach((option) => {
      option.closest("label")?.classList.toggle("is-selected", option === input);
    });

    if (bundlePrice) bundlePrice.textContent = price;
    if (bundleName) bundleName.textContent = name;
    if (bundleCta) {
      const isPendingPrice = price.includes("確認") || price.includes("公開") || price.includes("準備");
      const ctaLabel = isPendingPrice
        ? "Coming Soon"
        : `${name}の購入情報を確認する`;
      bundleCta.textContent = ctaLabel;
    }
  };

  bundleOptions.forEach((input) => {
    input.addEventListener("change", () => updateBundleChoice(input));
    if (input.checked) updateBundleChoice(input);
  });
}

const colorOptions = document.querySelectorAll("[data-color-option]");

if (colorOptions.length) {
  const colorName = document.querySelector("[data-color-name]");

  const updateColorChoice = (input) => {
    colorOptions.forEach((option) => {
      option.closest("label")?.classList.toggle("is-selected", option === input);
    });

    if (colorName) colorName.textContent = input.dataset.colorName || "";
  };

  colorOptions.forEach((input) => {
    input.addEventListener("change", () => updateColorChoice(input));
    if (input.checked) updateColorChoice(input);
  });
}

document.querySelectorAll("[data-info-tabs]").forEach((tabs) => {
  const tabButtons = tabs.querySelectorAll("[data-info-tab]");
  const tabPanels = tabs.querySelectorAll("[data-info-panel]");

  const activateTab = (button) => {
    const panelId = button.getAttribute("aria-controls");

    tabButtons.forEach((item) => {
      item.setAttribute("aria-selected", String(item === button));
    });

    tabPanels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  };

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => activateTab(button));
  });
});

const revealSelectors = [
  ".intro-statement",
  ".concept-wide-image",
  ".section-title",
  ".lineup-item",
  ".lineup-subhead",
  ".split-copy",
  ".split-media",
  ".solution-film",
  ".solution-film__copy",
  ".why-teaser > div",
  ".why-teaser > p",
  ".why-teaser .text-link",
  ".value-row figure",
  ".value-row > div",
  ".daily-head > *",
  ".daily-wide",
  ".daily-points article",
  ".recipe-copy",
  ".recipe-cut-strip figure",
  ".recipe-foot-copy",
  ".rice-storage-teaser figure",
  ".rice-storage-teaser > div",
  ".technology-deep > div",
  ".support-section .section-title",
  ".support-card-grid article",
  ".support-hero__copy",
  ".support-hero figure",
  ".support-quick article",
  ".support-step-grid article",
  ".support-split figure",
  ".support-split > div",
  ".support-trouble > *",
  ".support-guide .section-title",
  ".support-large-steps li",
  ".support-care-note",
  ".support-faq-list > *",
  ".support-manual-band > *",
  ".parts-list article",
  ".manual-list-section > *",
  ".pdp-support-guide > *",
  ".faq-list details",
  ".closing-cta > *",
  ".recipe-index__head > *",
  ".recipe-index__lead",
  ".recipe-card-grid article",
  ".recipe-library-note > *",
  ".editorial-hero > div",
  ".editorial-hero figure",
  ".editorial-index__head > *",
  ".journal-card",
  ".news-list article",
  ".recipe-detail-section__head > *",
  ".recipe-detail-card figure",
  ".recipe-detail-copy > *",
  ".single-recipe-hero__copy > *",
  ".single-recipe-hero__media",
  ".single-recipe-panel",
  ".single-recipe-memo",
  ".single-recipe-related > *",
  ".basic-cooking figure",
  ".basic-cooking > div",
  ".why-intro > *",
  ".why-reason-index article",
  ".why-origin",
  ".why-origin__copy",
  ".why-reason figure",
  ".why-reason > div",
  ".why-compare > *",
  ".why-tech figure",
  ".why-tech > div",
  ".why-daily-bridge > *",
  ".why-lineup > *",
  ".craft-intro > *",
  ".craft-split figure",
  ".craft-split > div",
  ".craft-feature",
  ".craft-feature > div",
  ".craft-process__head",
  ".craft-process figure",
  ".craft-process li",
  ".craft-process > p",
  ".craft-tech-bridge figure",
  ".craft-tech-bridge > div",
  ".craft-care figure",
  ".craft-care > div",
  ".craft-closing > *",
  ".pdp-title > *",
  ".pdp-model-switch > *",
  ".pdp-gallery",
  ".pdp-buybox",
  ".pdp-immersive-section",
  ".pdp-immersive-copy > *",
  ".pdp-visual-grid figure",
  ".pdp-feature-list article",
  ".pdp-feature-story figure",
  ".pdp-feature-story > div",
  ".pdp-daily-split > *",
  ".pdp-daily-list article",
  ".pdp-spec-note",
  ".pdp-spec-table div",
  ".pdp-family-grid article",
  ".ricepot-local-nav",
  ".ricepot-hero__copy > *",
  ".ricepot-lineup__head > *",
  ".ricepot-model-card",
  ".ricepot-lineup__actions",
  ".ricepot-link-card",
  ".ricepot-feature figure",
  ".ricepot-feature > div",
  ".ricepot-issue-solution figure",
  ".ricepot-issue-solution__copy > *",
  ".ricepot-life__head > *",
  ".ricepot-life__grid article",
  ".ricepot-usecase > div",
  ".ricepot-spec-section__head > *",
  ".ricepot-spec-table div",
  ".ricepot-cooking-strip article",
  ".ricepot-info-card",
  ".ricepot-related > div",
  ".ricepot-proof-strip > *",
  ".story-cross-links > *",
  ".story-cross-links a",
  ".pdp-model-lineup__head > *",
  ".pdp-model-lineup__grid a",
  ".lp2-expert-voice figure",
  ".lp2-expert-voice > div",
  ".ricepot-shop-banner > *",
  ".hero-proof > *",
  ".world-statement > *",
  ".material-proof > *",
  ".lp2-product-hero > *",
  ".lp2-opening-statement > *",
  ".lp2-trust-band > *",
  ".lp2-proof > *",
  ".lp2-campaign > *",
  ".lp2-section-head > *",
  ".lp2-solution > *",
  ".lp2-tech-concept > div > *",
  ".lp2-tech-story article > *",
  ".lp2-bubble-table dl div",
  ".lp2-size > *",
  ".lp2-model-compare article",
  ".lp2-info-band article",
  ".lp2-story > *",
];

const revealGroups = [
  ".lineup-shelf",
  ".hero-proof dl",
  ".value-stack",
  ".material-proof dl",
  ".daily-points",
  ".recipe-cut-strip",
  ".recipe-card-grid",
  ".journal-grid",
  ".why-reason-index",
  ".faq-list",
  ".craft-process ol",
  ".pdp-feature-list",
  ".pdp-family-grid",
  ".pdp-model-switch",
  ".ricepot-lineup__cards",
  ".ricepot-entry-grid",
  ".ricepot-life__grid",
  ".ricepot-cooking-strip",
  ".ricepot-proof-strip dl",
  ".story-cross-links nav",
  ".pdp-model-lineup__grid",
  ".ricepot-more-grid",
  ".ricepot-related__grid",
  ".lp2-proof__stats",
  ".lp2-benefits",
  ".lp2-tech-grid",
  ".lp2-compare-table",
  ".lp2-bubble-table dl",
  ".lp2-model-compare__grid",
  ".lp2-expert-voice",
  ".lp2-info-band",
  ".support-card-grid",
  ".support-quick",
  ".support-step-grid",
  ".support-large-steps",
  ".parts-list",
];

if (!motionQuery.matches && "IntersectionObserver" in window) {
  const revealItems = new Set();

  revealSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((item) => revealItems.add(item));
  });

  revealGroups.forEach((selector) => {
    document.querySelectorAll(selector).forEach((group) => {
      [...group.children].forEach((item, index) => {
        item.style.setProperty("--reveal-delay", `${Math.min(index * 70, 420)}ms`);
      });
    });
  });

  revealItems.forEach((item) => {
    item.classList.add("reveal-item");
    if (item.matches("figure, .concept-wide-image, .solution-film, .daily-wide, .why-origin, .craft-feature, .pdp-gallery, .support-hero figure, .ricepot-link-card, .ricepot-usecase")) {
      item.classList.add("reveal-media");
    }
  });

  document.documentElement.classList.add("motion-ready");

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  );

  revealItems.forEach((item) => {
    if (item.getBoundingClientRect().top < window.innerHeight * 0.88) {
      item.classList.add("is-visible");
    } else {
      revealObserver.observe(item);
    }
  });
} else {
  document.querySelectorAll(".reveal-item").forEach((item) => item.classList.add("is-visible"));
}

runWhenDomReady(() => {
  const technologyPage = document.querySelector(".technology-page--figma");
  if (!technologyPage) return;

  const motionItems = new Set();
  const motionSelectors = [
    ".tech-intro",
    ".tech-origin-panel > *",
    ".tech-anchor-nav",
    ".tech-chapter__hero",
    ".tech-chapter__body > *",
    ".tech-material-heat-panel__head > *",
    ".tech-material-heat-panel__body > *",
    ".tech-model-difference > *",
    ".tech-more-v3 > *",
  ];

  motionSelectors.forEach((selector) => {
    technologyPage.querySelectorAll(selector).forEach((item) => motionItems.add(item));
  });

  const staggerGroups = [
    ".tech-material-heat-panel__compare",
    ".tech-material-heat-panel__notes",
    ".tech-material-lines",
    ".tech-compare-lines",
    ".tech-control-flow",
    ".tech-step-list",
    ".tech-more-v3__links",
  ];

  staggerGroups.forEach((selector) => {
    technologyPage.querySelectorAll(selector).forEach((group) => {
      [...group.children].forEach((item, index) => {
        motionItems.add(item);
        item.style.setProperty("--tech-motion-delay", `${Math.min(index * 85, 425)}ms`);
      });
    });
  });

  motionItems.forEach((item) => {
    item.classList.add("tech-motion-item");
    if (item.matches("figure, .tech-chapter__hero, .tech-origin-panel > figure")) {
      item.classList.add("tech-motion-media");
    }
  });

  const showAllMotionItems = () => {
    motionItems.forEach((item) => item.classList.add("is-tech-visible"));
  };

  if (motionQuery.matches || !("IntersectionObserver" in window)) {
    showAllMotionItems();
  } else {
    technologyPage.classList.add("is-motion-enabled");
    const technologyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-tech-visible");
          technologyObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -10% 0px" },
    );

    motionItems.forEach((item) => {
      if (item.getBoundingClientRect().top < window.innerHeight * 0.9) {
        item.classList.add("is-tech-visible");
      } else {
        technologyObserver.observe(item);
      }
    });
  }

  const anchorLinks = [...technologyPage.querySelectorAll('.tech-anchor-nav a[href^="#tech"]')];
  const chapters = [...technologyPage.querySelectorAll(".tech-chapter[id]")];
  if (!anchorLinks.length || !chapters.length) return;

  const setCurrentChapter = (chapterId) => {
    anchorLinks.forEach((link) => {
      const isCurrent = link.getAttribute("href") === `#${chapterId}`;
      link.classList.toggle("is-current", isCurrent);
      if (isCurrent) link.setAttribute("aria-current", "location");
      else link.removeAttribute("aria-current");
    });
  };

  let chapterTicking = false;
  const updateCurrentChapter = () => {
    chapterTicking = false;
    const readingLine = window.scrollY + window.innerHeight * 0.38;
    let currentChapter = chapters[0];
    chapters.forEach((chapter) => {
      if (chapter.offsetTop <= readingLine) currentChapter = chapter;
    });
    setCurrentChapter(currentChapter.id);
  };

  const requestChapterUpdate = () => {
    if (chapterTicking) return;
    chapterTicking = true;
    window.requestAnimationFrame(updateCurrentChapter);
  };

  updateCurrentChapter();
  window.addEventListener("scroll", requestChapterUpdate, { passive: true });
  window.addEventListener("resize", requestChapterUpdate);
});

const parallaxSelectors = [
  ".concept-wide-image > img",
  ".concept-wide-image > video",
  ".split-media > img",
  ".split-media > video",
  ".solution-film > img",
  ".solution-film > video",
  ".value-row figure > img",
  ".value-row figure > video",
  ".daily-wide > img",
  ".daily-wide > video",
  ".recipe-cut-strip figure > video",
  ".recipe-main-photo > img",
  ".editorial-hero figure > img",
  ".journal-card > img",
  ".recipe-band figure > img",
  ".basic-cooking figure > img",
  ".product-hero__media > img",
  ".recipe-hero__media > img",
  ".why-hero__slides > img",
  ".why-origin > img",
  ".why-reason figure > img",
  ".why-tech figure > img",
  ".why-daily-bridge figure > img",
  ".craft-feature > img",
  ".technology-deep > video",
  ".craft-split figure > img",
  ".craft-process figure > img",
  ".craft-tech-bridge figure > img",
  ".craft-care figure > img",
  ".pdp-top-hero figure > video",
  ".pdp-photo-wall figure > img",
  ".pdp-immersive-section figure > img",
  ".ricepot-hero__media > img",
  ".ricepot-link-card figure > img",
  ".ricepot-link-card figure > video",
  ".ricepot-feature figure > img",
  ".ricepot-feature figure > video",
  ".ricepot-issue-solution figure > img",
  ".ricepot-issue-solution figure > video",
  ".ricepot-cooking-strip article > img",
  ".ricepot-cooking-strip article > video",
  ".ricepot-usecase > video",
  ".ricepot-usecase figure > video",
  ".lp2-solution figure > img",
  ".lp2-solution figure > video",
  ".lp2-gallery__motion > video",
  ".lp2-tech-concept > img",
  ".lp2-tech-concept > video",
  ".lp2-tech-grid article > video",
  ".lp2-tech-story figure > img",
  ".lp2-tech-story figure > video",
  ".lp2-expert-voice figure > img",
  ".lp2-size figure > img",
  ".lp2-size figure > video",
  ".lp2-story figure > img",
  ".lp2-story figure > video",
  ".lp2-model-compare article > video",
  ".pdp-feature-story figure > img",
  ".pdp-daily-split figure > img",
  ".support-hero figure > img",
  ".support-split figure > img",
  ".support-split figure > video",
];

if (!motionQuery.matches) {
  const parallaxItems = [];

  parallaxSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((media) => {
      const frame = media.closest("figure, .concept-wide-image, .split-media, .solution-film, .daily-wide, .recipe-main-photo, .recipe-hero__media, .why-hero__slides, .why-origin, .craft-feature, .technology-deep, .product-hero__media, .pdp-immersive-section, .ricepot-hero__media, .ricepot-link-card, .ricepot-cooking-strip article, .ricepot-usecase, .journal-card, .lp2-tech-concept");
      if (!frame || frame.classList.contains("is-contain")) return;

      frame.classList.add("parallax-frame");
      media.classList.add("parallax-media-item");
      parallaxItems.push({ frame, media });
    });
  });

  let parallaxTicking = false;

  const updateParallax = () => {
    parallaxTicking = false;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const strength = window.innerWidth < 760 ? 24 : 46;

    parallaxItems.forEach(({ frame, media }) => {
      const rect = frame.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > viewportHeight + 120) return;

      const centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
      const travel = Math.max(rect.height + viewportHeight, 1);
      const y = Math.max(-strength, Math.min(strength, (-centerOffset / travel) * strength * 2));
      media.style.setProperty("--parallax-y", `${y.toFixed(2)}px`);
    });
  };

  const requestParallax = () => {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(updateParallax);
  };

  updateParallax();
  window.addEventListener("scroll", requestParallax, { passive: true });
  window.addEventListener("resize", requestParallax);
}

const campaignPopupClosedKey = "kamano-v5-campaign-popup-closed";
const shouldShowCampaignPopup =
  !document.body.classList.contains("product-detail-first-page") &&
  sessionStorage.getItem(campaignPopupClosedKey) !== "true";

if (shouldShowCampaignPopup) {
  const campaignPopup = document.createElement("aside");
  campaignPopup.className = "campaign-popup";
  campaignPopup.setAttribute("aria-label", "2合モデルのLINE事前登録案内");
  campaignPopup.innerHTML = `
    <button class="campaign-popup__close" type="button" aria-label="閉じる"></button>
    <div class="campaign-popup__body">
      <p class="campaign-popup__label">Makuake 2026.09.26 START</p>
      <strong>目指したのは、世界一。</strong>
      <em class="campaign-popup__subcopy">感動の2合モデル、ついに登場。</em>
      <span>開始日や限定情報はLINEへ。</span>
      <div class="campaign-popup__actions">
        <a class="campaign-popup__primary" href="https://lin.ee/TcQglOu" data-line-pre-entry>LINE登録する</a>
        <a class="campaign-popup__secondary" href="${makuakeTeaserLocalHref}" data-placeholder-link="shopify-teaser" data-production-href="${makuakeTeaserProductionHref}">特別ページを見る</a>
      </div>
    </div>
  `;
  document.body.append(campaignPopup);

  const showCampaignPopup = () => {
    if (sessionStorage.getItem(campaignPopupClosedKey) === "true") return;
    campaignPopup.classList.add("is-visible");
  };

  const teaserSection = document.querySelector(".makuake-teaser");
  if (teaserSection && "IntersectionObserver" in window) {
    const teaserObserver = new IntersectionObserver(
      ([entry]) => {
        campaignPopup.classList.toggle("is-suppressed", entry.isIntersecting);
      },
      { threshold: 0.18 },
    );
    teaserObserver.observe(teaserSection);
  }

  const closeCampaignPopup = () => {
    sessionStorage.setItem(campaignPopupClosedKey, "true");
    campaignPopup.classList.remove("is-visible");
  };

  const showCampaignPopupOnScroll = () => {
    if (window.scrollY < 24) return;
    showCampaignPopup();
    window.removeEventListener("scroll", showCampaignPopupOnScroll);
  };

  campaignPopup.querySelector(".campaign-popup__close")?.addEventListener("click", closeCampaignPopup);
  campaignPopup.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      campaignPopup.classList.remove("is-visible");
    });
  });
  window.setTimeout(showCampaignPopup, 3000);
  window.addEventListener("scroll", showCampaignPopupOnScroll, { passive: true });
}

const fixedPurchaseCta = document.createElement("aside");
const currentShopifyPath = decodeURIComponent(window.location.pathname.replace(/\/$/, "") || "/");
const isTwoGoPdp = currentShopifyPath === "/products/kamano-donabe-2g";
const isFourGoPdp = currentShopifyPath === "/products/kamano-donabe-4g" || currentShopifyPath === "/products/kamano-donabe-4合";
const shouldShowFixedPurchaseCta = isTwoGoPdp || isFourGoPdp;

if (shouldShowFixedPurchaseCta) {
  fixedPurchaseCta.className = "fixed-purchase-cta";
  fixedPurchaseCta.setAttribute("aria-label", "KAMANO DONABEのモデル導線");
  if (isTwoGoPdp) {
    fixedPurchaseCta.innerHTML = `
      <span>2合モデル</span>
      <a href="https://lin.ee/TcQglOu">LINE登録</a>
      <a href="#spec">仕様</a>
    `;
  } else if (isFourGoPdp) {
    fixedPurchaseCta.innerHTML = `
      <span>4合モデル</span>
      <a href="#purchase">購入する</a>
      <a href="/products/kamano-donabe-2g?view=kamano-donabe-2g">比較</a>
    `;
  }
  document.body.classList.add("has-fixed-purchase-cta");
  document.body.append(fixedPurchaseCta);
}

if (isTwoGoPdp) {
  const hero = document.querySelector(".rice2-hero");
  const conceptAfterCta = document.querySelector(".rice2-concept-after-cta");
  if (hero) {
    document.body.classList.add("defer-fixed-purchase-cta");
    const updateFixedPurchaseVisibility = () => {
      const conceptEnd = conceptAfterCta
        ? conceptAfterCta.offsetTop + conceptAfterCta.offsetHeight - window.innerHeight * 0.45
        : 0;
      const threshold = Math.max(hero.offsetHeight * 0.72, conceptEnd, window.innerHeight * 0.68);
      document.body.classList.toggle("show-fixed-purchase-cta", window.scrollY > threshold);
    };

    updateFixedPurchaseVisibility();
    window.addEventListener("scroll", updateFixedPurchaseVisibility, { passive: true });
    window.addEventListener("resize", updateFixedPurchaseVisibility);
  }
}
